module.exports = __webpack_public_path__ + "img/logo-brandme1.73e80ec3.png";